module.exports = __webpack_public_path__ + "img/tanom_top.2f3cb71a.png";